
declare var swal:any

class HttpClient{
    constructor(){}
    async postJson(url, body, success, error) {
        
            fetch(url, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ',
                    'pragma': 'no-cache',
                    'cache-control': 'no-cache'
                },
                body: JSON.stringify(body)
            })
                .then(function (response) {
                    if (response.ok) {
                        const contentType = response.headers.get("content-type");
                        if (contentType && contentType.indexOf("application/json") !== -1) {
                            response.json().then(success)
                        }
                        else {
                            success(null)
                        }
                    }
                    else {
                        response.text().then(e => {
                            if (response.status == 401) {
                                swal("User session expired, you need to login again")
                            }
                            else if (error) {
                                error(e, response.status)
                            }
                        })
                    }
                })
        }
        
        async getJson(url, success, error) {
            await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ',
                    'pragma': 'no-cache',
                    'cache-control': 'no-cache',
                    'mode':'*'
                }
            })
                .then(function (response) {
             
                    if (response.ok) {
                        const contentType = response.headers.get("content-type");
                        if (contentType && contentType.indexOf("application/json") !== -1) {
                            response.json().then(success)
                        }
                        success()
                    } else {
                        response.text().then(e => {
                            if (response.status == 401) {
                                swal("User session expired, you need to login again")
                            } else if (error) {
                                error(e, response.status)
                            }
                        })
                    }
                })
        }
        
        async postFile(url, file, success, error) {
            var data = new FormData()
            data.append('file', file)
            await fetch(url, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    // 'Content-Type': 'application/json',
                    // 'Content-Type': 'multipart/form-data',
                    'Authorization': 'Bearer ',
                    'pragma': 'no-cache',
                    'cache-control': 'no-cache',
                    'mode':'cors'
                },
                body: data
            })
                .then(function (response) {
                    if (response.ok) {
                        const contentType = response.headers.get("content-type");
                        if (contentType && contentType.indexOf("application/json") !== -1) {
                            response.json().then(success)
                        }
                        else {
                            success(null)
                        }
                    }
                    else {
                        response.text().then(e => {
                            if (response.status == 401) {
                                swal("User session expired, you need to login again")
                            }
                            else if (error) {
                                error(e, response.status)
                            }
                        })
                    }
                })
        }
        
}



export default HttpClient